import Reveal from "@/components/base/Reveal";

type CtaSectionProps = {
  onOpenConsult: () => void;
};

export default function CtaSection({ onOpenConsult }: CtaSectionProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20luxury%20background%20with%20soft%20diagonal%20golden%20light%20bands%20over%20deep%20charcoal%20surface%2C%20subtle%20warm%20gradient%20glow%2C%20minimal%20elegant%20texture%2C%20premium%20editorial%20atmosphere%2C%20no%20text%2C%20no%20people&width=1920&height=900&seq=yeonan-cta-band-01&orientation=landscape"
          alt="연안법무법인 무료 상담 안내 배경"
          title="연안법무법인 개인회생 무료 상담"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-background-50/85" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-20 text-center md:px-6 md:py-24">
        <Reveal>
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-6 bg-primary-500/70" />
            <span className="font-label text-xs md:text-sm text-primary-400">
              Free Consultation
            </span>
            <span className="h-px w-6 bg-primary-500/70" />
          </div>
          <h2 className="font-heading mt-5 text-2xl font-semibold leading-[1.4] text-foreground-950 md:text-4xl">
            혼자 고민하지 마세요.
            <br />
            <span className="text-primary-400">연안</span>이 가장 확실한 길을 안내합니다
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            첫 상담은 무료이며, 상담 내용은 철저히 비밀로 보호됩니다.
            <br />
            지금 상황을 남겨주시면 전문 변호사가 신속하게 연락드립니다.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <button
              type="button"
              onClick={onOpenConsult}
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 cursor-pointer sm:w-auto"
            >
              무료 상담예약
            </button>
            <a
              href="#diagnosis"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-700/40 px-8 py-3.5 text-sm text-foreground-800 transition-colors duration-300 hover:border-primary-500 hover:text-primary-400 cursor-pointer sm:w-auto"
            >
              자가진단 하기
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}